const state = () => ({
  modalErrorMessage: "",
  hasModalError: false,
  visualPingLinks: [],
  visualPingData: [],
  pagination: {
    sortBy: "",
    descending: false,
    page: 1,
    rowsPerPage: 50,
    rowsNumber: null
  },
  visualPingDataPagination: {
    sortBy: "datetime",
    descending: true,
    page: 1,
    rowsPerPage: 50,
    rowsNumber: null
  },
  visualPingLinkWithChanges: {},
  showLinkChanges: false
});

const getters = {};

const actions = {};

const mutations = {
  resetModalError(state) {
    state.modalErrorMessage = "";
  },
  enableModalError(state) {
    state.hasModalError = true;
  },
  disableModalError(state) {
    state.hasModalError = false;
    state.modalErrorMessage = "";
  },
  updateModalError(state, message) {
    state.modalErrorMessage = message;
  },
  updatePagination(state, val) {
    state.pagination.rowsPerPage = val.size;
    state.pagination.rowsNumber = val.count;
  },
  updatePaginationPage(state, val) {
    state.pagination.sortBy = val.sortBy;
    state.pagination.descending = val.descending;
    state.pagination.page = val.page;
  },
  setVisualPingDataPagination(state, val) {
    state.visualPingDataPagination.sortBy = val.sortBy;
    state.visualPingDataPagination.descending = val.descending;
    state.visualPingDataPagination.page = val.page;
    state.visualPingDataPagination.rowsPerPage = val.rowsPerPage;
    state.visualPingDataPagination.rowsNumber = val.rowsNumber;
  },
  updateVisualPingDataPagination(state, val) {
    state.visualPingDataPagination.rowsPerPage = val.size;
    state.visualPingDataPagination.rowsNumber = val.count;
  },
  updateVisualPingDataPaginationPage(state, val) {
    state.visualPingDataPagination.sortBy = val.sortBy;
    state.visualPingDataPagination.descending = val.descending;
    state.visualPingDataPagination.page = val.page;
  },
  updateVisualPingLinks(state, links) {
    if (state.visualPingLinks.length > 0) state.visualPingLinks = [];

    for (let i = 0; i < links.length; i++) {
      state.visualPingLinks.push(links[i]);
    }
  },
  updateVisualPingData(state, items) {
    if (state.visualPingData.length > 0) state.visualPingData = [];

    for (let i = 0; i < items.length; i++) {
      state.visualPingData.push(items[i]);
    }
  },
  updateVisualPingLinkWithChanges(state, linkWithNotifications) {
    state.visualPingLinkWithChanges = linkWithNotifications;
  },
  updateShowLinkChanges(state, val) {
    state.showLinkChanges = val;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};